export enum SocialMedia {
  Facebook = "facebook",
  Instagram = "instagram",
  Whatsapp = "whatsapp",
  Youtube = "youtube",
}
